export default "<div class=\"public-video-wrapper\">\n  <router-outlet></router-outlet>\n</div>\n"